import { statusInfo, statusBadgeBg, statusBadgeText, statusDotColor } from '../utils/statusUtils'
import { useProjectConfig } from '../lib/appContext'

interface StatusBadgeProps {
  status: string
  small?: boolean
}

export default function StatusBadge({ status, small = false }: StatusBadgeProps) {
  const { statuses } = useProjectConfig()
  const info = statusInfo(status, statuses)
  const bg   = statusBadgeBg(info)
  const text = statusBadgeText(info)
  const dot  = statusDotColor(info)

  return (
    <span
      className={`status-badge${small ? ' sm' : ''}`}
      style={{ background: bg, color: text }}
    >
      <span className={`badge-dot${small ? ' sm' : ''}`} style={{ background: dot }} />
      {info.kort}
    </span>
  )
}
